export default class ExchangeRateUnavailableError extends Error {
  constructor(public readonly currency: string, options?: { cause?: unknown }) {
    super(`Exchange rate unavailable for ${currency}`, options)
    this.name = 'ExchangeRateUnavailableError'
    this.cause = options?.cause
  }
}
